import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../i18n";

/**
 * Renders nothing while English is the only registered language, so it can sit
 * permanently on the login page and in the navbar. It appears on its own the
 * moment a second locale is added to src/i18n/index.ts.
 */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  if (LANGUAGES.length < 2) return null;

  return (
    <label className="language-switcher">
      <span className="language-switcher-label">{t("common.language")}</span>
      <select
        value={i18n.language}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
      >
        {LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
    </label>
  );
}
